export default __webpack_public_path__ + "static/media/person_2.c55430e6.png";